import { Field } from 'react-final-form';
import _ from 'lodash';

const Condition: React.FC<{ when: string; is: any }> = ({ when, is, children }) => (
    <Field name={when} subscription={{ value: true }}>
        {({ input: { value } }) => (_.isEqual(value, is) ? children : null)}
    </Field>
);

export default Condition;
